/**
 * Ids of one editing session (plan 3.3): the `editSessionId` every save of
 * the session carries (a UUID, so the server squashes the saves into one
 * version), and the token the editing frame and the app put on every bridge
 * message. Web Crypto where the runtime has it; older Hermes builds have
 * none, so a random v4 layout is the fallback. Neither is a secret: the
 * token only lets the app ignore messages no editing frame of this session
 * sent.
 */

function randomHex(length: number): string {
  let out = '';
  for (let index = 0; index < length; index += 1) {
    out += Math.floor(Math.random() * 16).toString(16);
  }
  return out;
}

/** An RFC 4122 version 4 UUID. */
export function createUuid(): string {
  const runtime = globalThis as typeof globalThis & { crypto?: { randomUUID?: () => string } };
  if (typeof runtime.crypto?.randomUUID === 'function') {
    try {
      return runtime.crypto.randomUUID();
    } catch {
      // Some runtimes expose it outside a secure context and throw.
    }
  }
  const variant = ['8', '9', 'a', 'b'][Math.floor(Math.random() * 4)];
  return `${randomHex(8)}-${randomHex(4)}-4${randomHex(3)}-${variant}${randomHex(3)}-${randomHex(12)}`;
}

/** The bridge session token: 32 URL-safe characters (the bridge takes 16 to 128). */
export function createEditorToken(): string {
  return createUuid().replace(/-/g, '');
}
